"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deepMerge = void 0;
var _defineProperty2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/defineProperty.js"));
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _isEmpty = require("../is-empty");
var _dataTypeOf = require("../data-type-of");
/** 深度合并对象
 * @description: 深度合并对象
 * @param { Object } target 原始对象
 * @param { ...Object[] } sources 待合并的对象，如果有多个，那么将会从第一个先合并到 target，然后在是第二个依次往下，最后一个参数将会是最后合并到 target 的
 * @return { Object } 返回对象
 */
var _deepMerge = exports.deepMerge = function deepMerge() {
  var _sources$filter;
  var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }
  sources
  /* 过滤掉 空对象 以及 非对象 */ === null || sources
  /* 过滤掉 空对象 以及 非对象 */ === void 0 || (_sources$filter = sources
  /* 过滤掉 空对象 以及 非对象 */.filter(function (source) {
    return (0, _isEmpty.isNoEmpty)(source) && (0, _dataTypeOf.dataTypeOf)(source) === 'object';
  })) === null || _sources$filter === void 0 || _sources$filter.forEach(function (source) {
    Object.keys(source).forEach(function (key) {
      if ((0, _dataTypeOf.dataTypeOf)(source[key]) !== 'object') Object.assign(target, (0, _defineProperty2.default)({}, key, source[key]));else {
        if (!target[key]) Object.assign(target, (0, _defineProperty2.default)({}, key, {}));
        _deepMerge(target[key], source[key]);
      }
    });
  });
  return target;
};